import PropTypes from 'prop-types';
import React, { Component } from 'react';
const Immutable = require('immutable');
const { HYPHEN } = require('constants');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { FormattedText, getLanguage } = require('core/i18n').i18n;
// @ helpers
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { getLastNChars } = require('utilities/stringHelper');

class PlanItem extends Component {
    render() {
        const { plan } = this.props;
        let totalValue = HYPHEN;
        let leftContents;

        if(!plan.isOrigin) {
            leftContents = (
                <div className="dropdown-plans__account-description-amount">
                    <FormattedText
                        value="brokerDropdownPlans-dgsCode"
                        injectedStrings={[
                            plan.dgsCode
                        ]}/>
                </div>
            )
        } else {
            if (plan.totalValue !== HYPHEN) {
                const ammountObject = Immutable.fromJS({
                    amount: plan.totalValue,
                    currency: plan.totalValueCurrency
                });

                const plainAmountObject = getPlainAmountObject(ammountObject);

                totalValue = (
                    <OneLineSymbolAmount
                        amountObject={plainAmountObject}
                        language={getLanguage()}
                        amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                )

                leftContents = (
                    <div className="dropdown-plans__account-description-amount">
                        <FormattedText value="brokerDropdownPlans-value"/>
                        { totalValue }
                    </div>
                );
            }
        }

        return (
            <div>
                <div className="dropdown-plans__account-description-left">
                    <span className="dropdown-plans__account-description-alias">{plan.name}</span>
                    <span className="dropdown-plans__account-description-iban">{getLastNChars(plan.contract)}</span>
                </div>
                {leftContents}
            </div>
        );
    }
}

PlanItem.propTypes = {
    plan: PropTypes.object.isRequired,
};

module.exports = PlanItem;